/* SSUK supporting pages behaviour, 27 Sept 2026. No dependencies.
   - FAQ accordions (keyboard friendly: they are real buttons)
   - FAQ search that filters every answer on the page
   - Category chips and "most asked" tiles that jump to an answer
   - Brand E14 "steps on the road": sizes the road and dashes from the first disc to the last
   Safe to load on any page: every part checks its markup exists first. */
(function () {
  if (window.__ssukPg) return; window.__ssukPg = true;

  function openQa(qa, open) {
    qa.classList.toggle('open', open);
    var b = qa.querySelector(':scope > button');
    if (b) b.setAttribute('aria-expanded', String(open));
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.pg-qa > button');
    if (b) { var qa = b.parentElement; openQa(qa, !qa.classList.contains('open')); return; }

    var j = e.target.closest('[data-pg-jump]');
    if (j) {
      var t = document.getElementById(j.getAttribute('data-pg-jump'));
      if (!t) return;
      e.preventDefault();
      if (t.classList.contains('pg-qa')) openQa(t, true);
      document.querySelectorAll('.pg-chip.on').forEach(function (c) { c.classList.remove('on'); });
      if (j.classList.contains('pg-chip')) j.classList.add('on');
      t.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
  });

  /* FAQ search */
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-pg-faq-search]')) return;
    var q = e.target.value.trim().toLowerCase(), shown = 0;
    document.querySelectorAll('.pg-qa').forEach(function (qa) {
      var hit = !q || qa.textContent.toLowerCase().indexOf(q) > -1;
      qa.hidden = !hit; if (hit) shown++;
      if (q && hit) openQa(qa, false);
    });
    document.querySelectorAll('.pg-faq-cat').forEach(function (c) {
      c.hidden = !c.querySelector('.pg-qa:not([hidden])');
    });
    var tiles = document.querySelector('[data-pg-tiles]'); if (tiles) tiles.hidden = !!q;
    var out = document.querySelector('[data-pg-faq-count]');
    if (out) out.textContent = q ? (shown + (shown === 1 ? ' answer' : ' answers') + ' for "' + e.target.value.trim() + '"') : '';
    var empty = document.querySelector('[data-pg-faq-empty]'); if (empty) empty.hidden = !(q && shown === 0);
  });

  /* E14 roads */
  function roads() {
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    document.querySelectorAll('.pg-road').forEach(function (r) {
      var d = r.querySelectorAll('.pg-disc'), tr = r.querySelector('.track'), ds = r.querySelector('.dash');
      if (d.length < 2 || !tr || !ds) return;
      var R = r.getBoundingClientRect(), a = d[0].getBoundingClientRect(), b = d[d.length - 1].getBoundingClientRect(), cap = 22;
      if (mobile) {
        var cx = a.left + a.width / 2 - R.left, y1 = a.top + a.height / 2 - R.top, y2 = b.top + b.height / 2 - R.top;
        Object.assign(tr.style, { left: (cx - 7) + 'px', width: '14px', top: (y1 - cap) + 'px', height: (y2 - y1 + 2 * cap) + 'px' });
        Object.assign(ds.style, { left: (cx - 1) + 'px', width: '2px', top: y1 + 'px', height: (y2 - y1) + 'px' });
      } else {
        var cy = a.top + a.height / 2 - R.top, x1 = a.left + a.width / 2 - R.left, x2 = b.left + b.width / 2 - R.left;
        Object.assign(tr.style, { left: (x1 - cap) + 'px', width: (x2 - x1 + 2 * cap) + 'px', top: (cy - 7) + 'px', height: '14px' });
        Object.assign(ds.style, { left: x1 + 'px', width: (x2 - x1) + 'px', top: (cy - 1) + 'px', height: '2px' });
      }
    });
  }
  var t; function later() { clearTimeout(t); t = setTimeout(roads, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', roads); else roads();
  window.addEventListener('load', roads);
  window.addEventListener('resize', later);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(roads);
  document.addEventListener('shopify:section:load', roads);

  /* The theme's --header-height is the full header; once scrolled, only the sticky part stays.
     Measure what is actually pinned so the FAQ chip bar and jump targets sit right under it. */
  function stick() {
    var h = document.querySelector('.shopify-section-group-header-group[id*="__header"], [id^="shopify-section-"][id$="__header"]');
    var y = 0;
    if (h) { var r = h.getBoundingClientRect(); if (getComputedStyle(h).position === 'sticky' || getComputedStyle(h).position === 'fixed') y = Math.max(0, Math.round(r.bottom)); }
    document.documentElement.style.setProperty('--pg-stick', y + 'px');
  }
  if (document.querySelector('.pg-chipbar, .pg-aside, [data-pg-jump]')) {
    var ticking = false;
    var settle;
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(function () { stick(); ticking = false; }); }
      clearTimeout(settle); settle = setTimeout(stick, 400); /* the header animates while it collapses */
    }, { passive: true });
    var hs = document.querySelector('[id^="shopify-section-"][id$="__header"]');
    if (hs && window.ResizeObserver) new ResizeObserver(stick).observe(hs);
    if (hs) hs.addEventListener('transitionend', stick, true);
    window.addEventListener('resize', stick);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stick); else stick();
  }

  /* Leave room for the mobile action bar */
  if (document.querySelector('.pg-mbar')) document.documentElement.classList.add('pg-has-mbar');
})();
